'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deletes = exports.patch = exports.put = exports.post = exports.get = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generates a method that makes HTTP requests of a certain type.
 * @param {Object} config - The options for the generated method.
 * @returns {Function} The method that makes requests.
 */
var generateMethod = function generateMethod(config) {
  if (config.withBody) {
    return function (input) {
      var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var init = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var options = _extends({}, init, { method: config.methodName });

      if (headers) {
        options.headers = headers;
      }

      if (body) {
        options.body = JSON.stringify(body);
      }

      return (0, _isomorphicFetch2.default)(input, options);
    };
  }

  return function (input) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return (0, _isomorphicFetch2.default)(input, headers ? _extends({}, init, { method: config.methodName, headers: headers }) : _extends({}, init, { method: config.methodName }));
  };
};

/**
 * Sends a GET request.
 * @param {String} input - The resource to fetch.
 * @param {Object} [headers=null] - Headers for the request.
 * @param {Object} [init={}] - Additional options for the request.
 * @returns {Promise<Object>} The response.
 */
var get = exports.get = generateMethod({
  methodName: 'GET',
  withBody: false
});

/**
 * Sends a POST request.
 * @param {String} input - The resource to fetch.
 * @param {Object} [headers=null] - Headers for the request.
 * @param {Object} [body=null] - Body for the request.
 * @param {Object} [init={}] - Additional options for the request.
 * @returns {Promise<Object>} The response.
 */
var post = exports.post = generateMethod({
  methodName: 'POST',
  withBody: true
});

/**
 * Sends a PUT request.
 * @param {String} input - The resource to fetch.
 * @param {Object} [headers=null] - Headers for the request.
 * @param {Object} [body=null] - Body for the request.
 * @param {Object} [init={}] - Additional options for the request.
 * @returns {Promise<Object>} The response.
 */
var put = exports.put = generateMethod({
  methodName: 'PUT',
  withBody: true
});

/**
 * Sends a PATCH request.
 * @param {String} input - The resource to fetch.
 * @param {Object} [headers=null] - Headers for the request.
 * @param {Object} [body=null] - Body for the request.
 * @param {Object} [init={}] - Additional options for the request.
 * @returns {Promise<Object>} The response.
 */
var patch = exports.patch = generateMethod({
  methodName: 'PATCH',
  withBody: true
});

/**
 * Sends a DELETE request.
 * @param {String} input - The resource to fetch.
 * @param {Object} [headers=null] - Headers for the request.
 * @param {Object} [body=null] - Body for the request.
 * @param {Object} [init={}] - Additional options for the request.
 * @returns {Promise<Object>} The response.
 */
var deletes = exports.deletes = generateMethod({
  methodName: 'DELETE',
  withBody: true
});


//////////////////
// WEBPACK FOOTER
// ./src/v2/requests/Methods.js
// module id = 812
// module chunks = 0